export const BRAND = {
  NAME: "TIC",
};
